import PropTypes from 'prop-types';
import React from 'react';

const ConfirmBarber = ({
  isFetching,
  successMessage,
  errorMessage,
}) => (
  <div className="u-text-center">
    <h2 className="c-heading u-mv+">Confirm professional</h2>
    { isFetching ?
      <div className="c-heading--large">Confirming professional... Please wait...</div>
    :
      <div className="c-heading--large">
        {successMessage || errorMessage}
      </div>
    }
  </div>
);
ConfirmBarber.propTypes = {
  isFetching: PropTypes.bool,
  successMessage: PropTypes.string,
  errorMessage: PropTypes.string,
};
ConfirmBarber.defaultProps = {
  isFetching: false,
  successMessage: '',
  errorMessage: '',
};

export default ConfirmBarber;




// WEBPACK FOOTER //
// ./src/app/confirmation/components/ConfirmBarber.jsx